import { Dispatch, SetStateAction, useState } from 'react'
import styles from './Parameter.module.css'
import { Col, Row } from "react-bootstrap"
import { gql } from '@apollo/client'
import { useApolloClient } from '@apollo/client/react'
import { AlertItem } from '../../../../../components/notification/Notification'

const MODIFY_PARAMETER_QUERY = gql`
    mutation UpdateSystemParameter($updateSystemParameterInput: UpdateSystemParameterInput!) {
        updateSystemParameter(updateSystemParameterInput: $updateSystemParameterInput) {
            id
            name
            value
            type
            description
        }
    }
`

export type ParameterPropsType = {
    parameter: SystemParameterType
    isEditing: boolean
    onStartEdit: () => void
    onStopEdit: () => void
    setAlerts: Dispatch<SetStateAction<AlertItem[]>>
    odd: boolean
    setSystemParameter: (x: SystemParameterType) => void
}
export type SystemParameterType = {
    id: number
    name: string
    value: string
    type: string
    description: string
}

interface modifyParameterResult {
    updateSystemParameter: SystemParameterType
}

export default function Parameter({ parameter, isEditing, onStartEdit, onStopEdit, setAlerts, odd, setSystemParameter }: ParameterPropsType) {
    const { id, name, type, value, description } = parameter
    const client = useApolloClient()
    const [ showInfo, setShowInfo ] = useState(false)
    const [ parameterValue, setParameterValue ] = useState("")
    const [ isEdit, setIsEdit ] = useState(false)

    const modifyParameter = async () => {
        try {
            if(parameterValue === "") {
                throw new Error("Kérem adja meg az új érteket módosítás elött!")
            }
            
            const response = await client.mutate<modifyParameterResult>({
                mutation: MODIFY_PARAMETER_QUERY,
                variables: {
                    updateSystemParameterInput: {
                        value: parameterValue,
                        id
                    }
                },
                fetchPolicy: 'no-cache'
            })
            
            const updateSystemParameter = response.data!.updateSystemParameter
            if(updateSystemParameter) {
                setSystemParameter(updateSystemParameter)
                
                const alert: AlertItem = {
                    id: new Date().getTime(),
                    type: "success",
                    title: `Sikeres módosítás`,
                    message: `Sikeres módosítás`
                }
                setAlerts(prev => [...prev, alert])
                setParameterValue("")
                return
            }

            throw new Error("Hiba a módosítás közben!")

        }
        catch(e: any) {
            const alert: AlertItem = {
                id: new Date().getTime(),
                type: "danger",
                title: `Sikertelen módosítás`,
                message: e.message
            }
            setAlerts(prev => [...prev, alert])
        }
    }
    
    return(
        <Row style={odd ? {backgroundColor: "rgb(0, 0, 0, 0.1)"} : {backgroundColor: "rgb(0, 0, 0, 0.3)"}} className={styles.containerBody}>
            <Col sm="3">{id}</Col>
            <Col sm="3">
                {name}
                <span
                    className={styles.helpIcon}
                    onMouseEnter={() => setShowInfo(true)}
                    onMouseLeave={() => setShowInfo(false)}
                    >
                    <img src="/question.png" alt="question" />
                    {showInfo && (
                        <div className={styles.tooltip}>
                            <strong>{description}</strong>
                        </div>
                    )}
                </span>
            </Col>

            {
                isEditing
                    ?
                        <>
                            <Col sm="4">
                                <input type={type.toLowerCase() === "string" ? "text" : "number"} autoFocus placeholder={value} onChange={e => {
                                    const parameterValue = e.target.value
                                    setParameterValue(parameterValue)
                                }}/>
                            </Col>

                            <Col sm="1">
                                <button className={ styles.btn } title='Bezár' onClick={() => onStopEdit()}>
                                    <img className={ styles.image } src="/buttons/close.png" alt="modify" />
                                </button>
                            </Col>

                            <Col sm="1">
                                <button className={ styles.btn } title='Mentés' onClick={e => {
                                    e.preventDefault()
                                    onStopEdit()
                                    modifyParameter()
                                    setIsEdit(!isEdit)
                                }}>
                                    <img className={ styles.image } src="/buttons/save.png" alt="modify" />
                                </button>
                            </Col>
                        </>
                    :
                        <>
                            <Col sm="4">{value}</Col>

                            <Col sm="2">
                                <button className={ styles.btn } onClick={() => {
                                    setIsEdit(!isEdit)
                                    onStartEdit()
                                }}>
                                    <img className={ styles.image } src="/buttons/modify_button.png" alt="modify" />
                                </button>
                            </Col>
                        </>
            }

        </Row>
    )
}